import { render, staticRenderFns } from "./businessDashboard.vue?vue&type=template&id=5b8c72d8&scoped=true"
import script from "./businessDashboard.vue?vue&type=script&lang=js"
export * from "./businessDashboard.vue?vue&type=script&lang=js"
import style0 from "./businessDashboard.vue?vue&type=style&index=0&id=5b8c72d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8c72d8",
  null
  
)

export default component.exports